import styled from 'styled-components';

interface ITextArea {
    onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    maxLength?: number;
    placeholder?: string;
    style?: any;
    value?: string;
}

const Container = styled.textarea`
    color: ${(props) => props.theme.colors.title};
    height: fit-content;
    border: none;
    border-bottom: 1px solid ${(props) => props.theme.colors.line};
    outline: none;
    padding-bottom: 8px;
    width: 100%;
    resize: none;
    overflow: hidden;

    textarea:focus {
        border: none;
    }

    textarea:active {
        border: none;
    }

    ::placeholder{
      color: ${(props) => props.theme.colors.placeholder};
    }

    @media only screen and (max-width: 950px){
        width: 100%; 
    }
`;

const TextArea: React.FC<ITextArea> = ({onChange, maxLength, placeholder, style, value}) => {
    return (
        <Container onChange={onChange} maxLength={maxLength} placeholder={placeholder} style={style} value={value}/>
    )
}

export default TextArea;